import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { prismicImage } from 'src/common/utils/prismic-image';
import Options from './Options';
import './CountryToggle.scss';

export const CountryToggle = props => (
  <div
    className={cx('country-toggle', { 'country-toggle--flush': props.isFlush })}>
    <button
      className="country-toggle-pill"
      type="button"
      onClick={props.handleCountryClick}>
      <img
        src={prismicImage(props.country.flag)}
        alt={props.country.iso}
        className="country-toggle-image"
      />{' '}
      <span className="country-toggle-text">{props.country.name}</span>
    </button>
    {props.isOpen && (
      <Options
        for="country"
        countries={props.countries}
        currentValue={props.country}
        open={props.isOpen}
        title={props.countryHeading}
        onClose={props.handleCountryClick}
        changeCountryLink={props.changeCountryLink}
      />
    )}
  </div>
);

CountryToggle.propTypes = {
  country: PropTypes.shape({
    flag: PropTypes.object.isRequired,
    iso: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  countries: PropTypes.array.isRequired,
  isFlush: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  changeCountryLink: PropTypes.string.isRequired,
  countryHeading: PropTypes.string.isRequired,
  handleCountryClick: PropTypes.func.isRequired,
};

export default CountryToggle;
